import { resolveApiErrorMessage } from 'app/api/app-api/apiHooksHelpers';
import Styled from 'app/modules/registration/StyledRegistrationUi';
import defaultRecoverClient from "../recoverClient";
import defaultRegisterClient from "../registerClient";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ActivateError, LinkExpired, SubscriptionActivated, UserSubmitted } from "./ActivationVariants";
import { SetPasswordModes } from "./LoginTypes";
import SetPasswordForm from "./SetPasswordForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SetPasswordPopup = _ref => {
  let {
    location: {
      search
    },
    mode,
    registerClient = defaultRegisterClient,
    recoverClient = defaultRecoverClient
  } = _ref;
  const [userStatus, setUserStatus] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [activateError, setActivateError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const apiClient = mode === SetPasswordModes.Register ? registerClient : recoverClient;
  useEffect(function verifyToken() {
    setIsLoading(true);
    apiClient.verifyToken(search).then(async res => {
      setUserStatus(res ?? null);
      if (res?.user?.status === 'ACTIVE') {
        try {
          await apiClient.submitUserData(search);
          setIsLoading(false);
        } catch (e) {
          const errorMessage = await resolveApiErrorMessage(e);
          setActivateError(errorMessage);
        }
      }
    }).catch(async e => {
      setIsLoading(false);
      setIsExpired(true);
      const errorMessage = await resolveApiErrorMessage(e);
      setErrorMessage(errorMessage);
    }).finally(() => setIsLoading(false));
  }, [search, mode, registerClient, recoverClient]);
  if (isLoading) return /*#__PURE__*/_jsx(LoadingSpinner, {});
  return /*#__PURE__*/_jsx(Styled.Page, {
    $backgroundColor: "--white",
    "data-sentry-element": "unknown",
    "data-sentry-component": "SetPasswordPopup",
    "data-sentry-source-file": "SetPasswordPopup.tsx",
    children: /*#__PURE__*/_jsxs(Styled.Content, {
      $display: "flex",
      $flexDirection: "column",
      $alignItems: "center",
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "SetPasswordPopup.tsx",
      "data-sentry-element": "unknown",
      children: [userStatus?.user.status === 'INACTIVE' && /*#__PURE__*/_jsx(_Fragment, {
        children: !isSubmitted && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Styled.Heading, {
            level: 1,
            $mb: "1sp",
            children: "Thank you! Your account has been activated."
          }), /*#__PURE__*/_jsx(Styled.Heading, {
            as: "p",
            level: 2,
            $mb: "4sp",
            children: "Please, set your password."
          }), /*#__PURE__*/_jsx("div", {
            className: "LoginForm",
            children: /*#__PURE__*/_jsx(SetPasswordForm, {
              setSubmitted: setIsSubmitted,
              apiClient: apiClient,
              query: search,
              mode: mode
            })
          })]
        })
      }), !isExpired && !activateError && userStatus?.user.status === 'ACTIVE' && /*#__PURE__*/_jsx(SubscriptionActivated, {
        source: userStatus.source
      }), isSubmitted && /*#__PURE__*/_jsx(UserSubmitted, {
        mode: mode
      }), isExpired && /*#__PURE__*/_jsx(LinkExpired, {
        errorMessage: errorMessage
      }), activateError && /*#__PURE__*/_jsx(ActivateError, {
        error: activateError
      }), !userStatus && !isExpired && !isSubmitted && /*#__PURE__*/_jsxs("div", {
        className: "SetPasswordPopup LoginPopup__modal py-5",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "LoginPopup__title",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: 'auth.set-password.set-your-password'
          })
        }), /*#__PURE__*/_jsx(SetPasswordForm, {
          setSubmitted: setIsSubmitted,
          apiClient: apiClient,
          mode: mode,
          query: search
        })]
      })]
    })
  });
};
export default SetPasswordPopup;